import {
    FETCH_CUSTOMERS,
    FETCH_CUSTOMERS_SUCCESS,
    FETCH_CUSTOMERS_FAIL,
    SET_CUSTOMER_IN_VIEW,
    SET_STROMBOLI_OFF_SUCCESS,
    SET_STROMBOLI_ON_SUCCESS,
    CUSTOMER_REINIT_STATE,
    FETCH_VECTORS_FAIL,
    FETCH_VECTORS_SUCCESS,
    FETCH_VECTORS,
    FETCH_TARGET_SUCCESS,
    FETCH_TARGET,
    FETCH_TARGET_FAIL,
    FETCH_EVENTS,
    FETCH_EVENTS_SUCCESS,
    FETCH_EVENTS_FAIL,
    FETCH_ATTACKS_SUCCESS,
    FETCH_ATTACKS_FAIL,
    FETCH_ATTACKS,
    FETCH_CAMPAIGNS,
    FETCH_CAMPAIGNS_SUCCESS,
    FETCH_CAMPAIGNS_FAIL,
    FETCH_PERIMETER_ATTACKS_META,
    FETCH_PERIMETER_ATTACKS_META_SUCCESS,
    FETCH_PERIMETER_ATTACKS_META_FAIL,
    FETCH_ATTACK,
    FETCH_ATTACK_SUCCESS,
    FETCH_ATTACK_FAIL,
    ADD_CUSTOMER,
    ADD_CUSTOMER_SUCCESS,
    ADD_CUSTOMER_FAIL,
    SET_TARGET_SCOPE,
    SET_TARGET_SCOPE_SUCCESS,
    SET_TARGET_SCOPE_FAIL,
    CUSTOMER_MODULE_ACTIVATE,
    CUSTOMER_MODULE_ACTIVATE_SUCCESS,
    CUSTOMER_MODULE_ACTIVATE_FAIL,
    CUSTOMER_MODULE_DEACTIVATE,
    CUSTOMER_MODULE_DEACTIVATE_SUCCESS,
    CUSTOMER_MODULE_DEACTIVATE_FAIL,
    CUSTOMER_SUBSCRIPTION_DEACTIVATE_FAIL,
    CUSTOMER_SUBSCRIPTION_DEACTIVATE_SUCCESS,
    CUSTOMER_SUBSCRIPTION_DEACTIVATE,
    CUSTOMER_SUBSCRIPTION_ACTIVATE_FAIL,
    CUSTOMER_SUBSCRIPTION_ACTIVATE_SUCCESS,
    CUSTOMER_SUBSCRIPTION_ACTIVATE,
    ADD_TAG_CUSTOMER_SUCCESS,
    ADD_TAG_CUSTOMER_FAIL,
    UPDATE_TAG_CUSTOMER_SUCCESS,
    UPDATE_TAG_CUSTOMER_FAIL,
    FETCH_USERS_FOR_CUSTOMER,
    FETCH_USERS_FOR_CUSTOMER_SUCCESS,
    FETCH_USERS_FOR_CUSTOMER_FAIL,
    CREATE_USER_FOR_CUSTOMER,
    CREATE_USER_FOR_CUSTOMER_SUCCESS,
    CREATE_USER_FOR_CUSTOMER_FAIL,
    DELETE_USER_FOR_CUSTOMER,
    DELETE_USER_FOR_CUSTOMER_SUCCESS,
    DELETE_USER_FOR_CUSTOMER_FAIL,
    DELETE_USER_FOR_CUSTOMER_INVITE,
    DELETE_USER_FOR_CUSTOMER_INVITE_SUCCESS,
    DELETE_USER_FOR_CUSTOMER_INVITE_FAIL,
    UPDATE_CUSTOMER_NAME,
    UPDATE_CUSTOMER_NAME_SUCCESS, UPDATE_CUSTOMER_NAME_FAIL
} from 'constants/ActionTypes';
import {
    FETCH_HUMANS,
    FETCH_HUMANS_FAIL,
    FETCH_HUMANS_SUCCESS,
    FETCH_TARGETS, FETCH_TARGETS_FAIL, FETCH_TARGETS_SUCCESS,
    SET_STROMBOLI_OFF,
    SET_STROMBOLI_OFF_FAIL,
    SET_STROMBOLI_ON,
    SET_STROMBOLI_ON_FAIL
} from "../constants/ActionTypes";
import {addTag, updateTag} from "./Common";
import {bbIsObject} from "../util/bbHelpers";


/* ****************
Fetching customers from the db
 *******************/
export const fetchCustomers = () => {
    return {
        type: FETCH_CUSTOMERS
    };
};

export const fetchCustomersSuccess = (data) => {
    return {
        type: FETCH_CUSTOMERS_SUCCESS,
        payload: data
    };
};

export const fetchCustomersFail = (data) => {
    return {
        type: FETCH_CUSTOMERS_FAIL,
        payload: data
    };
};

/**
 * Summary. setCustomerInView
 *
 * Description. sets the customerInView state to the given customer ID
 *
 * @param {number|string}   customerId           The customerId number.
 */
export const setCustomerInView = (customerId) => {
    return {
        type: SET_CUSTOMER_IN_VIEW,
        payload: customerId
    };
};

export const setStromboliOff = (customerId) => {
    return {
        type: SET_STROMBOLI_OFF,
        payload: {customerId: customerId, newStatus: "0"}
    };
};

export const setStromboliOffSuccess = (customerId) => {
    return {
        type: SET_STROMBOLI_OFF_SUCCESS,
        payload: customerId
    };
};

export const setStromboliOffFail = () => {
    return {
        type: SET_STROMBOLI_OFF_FAIL
    };
};

export const setStromboliOn = (customerId) => {
    return {
        type: SET_STROMBOLI_ON,
        payload: {customerId: customerId, newStatus: "1"}
    };
};
export const setStromboliOnSuccess = (customerId) => {
    return {
        type: SET_STROMBOLI_ON_SUCCESS,
        payload: customerId
    };
};
export const setStromboliOnFail = () => {
    return {
        type: SET_STROMBOLI_ON_FAIL
    };
};

export const reinitCustomerState = () => {
    console.log("Reinitializing Customer State");
    return {
        type: CUSTOMER_REINIT_STATE
    };
};


//fetching targets
export const fetchTargets = (data) => {
    return {
        type: FETCH_TARGETS,
        payload: data
    };
};

export const fetchTargetsSuccess = (data) => {
    return {
        type: FETCH_TARGETS_SUCCESS,
        payload: data
    };
};

export const fetchTargetsFail = (data) => {
    return {
        type: FETCH_TARGETS_FAIL,
        payload: data
    };
};

export const fetchTargetAction = (data) => {
    return {
        type: FETCH_TARGET,
        payload: data
    };
};

export const fetchTargetSuccess = (data) => {
    return {
        type: FETCH_TARGET_SUCCESS,
        payload: data
    };
};

export const fetchTargetFail = (data) => {
    return {
        type: FETCH_TARGET_FAIL,
        payload: data
    };
};

//fetching human identities
export const fetchHumans = (data) => {
    return {
        type: FETCH_HUMANS,
        payload: data
    };
};

export const fetchHumansSuccess = (data) => {
    return {
        type: FETCH_HUMANS_SUCCESS,
        payload: data
    };
};

export const fetchHumansFail = (data) => {
    return {
        type: FETCH_HUMANS_FAIL,
        payload: data
    };
};

//fetching vectors
export const fetchVectorsAction = (data) => {
    return {
        type: FETCH_VECTORS,
        payload: data
    };
};

export const fetchVectorsSuccess = (data) => {
    return {
        type: FETCH_VECTORS_SUCCESS,
        payload: data
    };
};

export const fetchVectorsFail = () => {
    return {
        type: FETCH_VECTORS_FAIL
    };
};


//fetching events
export const fetchEventsAction = (data) => {
    return {
        type: FETCH_EVENTS,
        payload: data
    };
};

export const fetchEventsSuccess = (data) => {
    return {
        type: FETCH_EVENTS_SUCCESS,
        payload: data
    };
};

export const fetchEventsFail = () => {
    return {
        type: FETCH_EVENTS_FAIL
    };
};

//fetching attacks
export const fetchAttacksAction = (data) => {
    return {
        type: FETCH_ATTACKS,
        payload: data
    };
};

export const fetchAttacksSuccess = (data) => {
    return {
        type: FETCH_ATTACKS_SUCCESS,
        payload: data
    };
};

export const fetchAttacksFail = () => {
    return {
        type: FETCH_ATTACKS_FAIL
    };
};

//fetching a single attack
export const fetchAttackAction = (data) => {
    return {
        type: FETCH_ATTACK,
        payload: data
    };
};

export const fetchAttackSuccess = (data) => {
    return {
        type: FETCH_ATTACK_SUCCESS,
        payload: data
    };
};

export const fetchAttackFail = () => {
    return {
        type: FETCH_ATTACK_FAIL
    };
};

//fetching campaign vectors
export const fetchCampaignsAction = (data) => {
    return {
        type: FETCH_CAMPAIGNS,
        payload: data
    };
};

export const fetchCampaignsSuccess = (data) => {
    return {
        type: FETCH_CAMPAIGNS_SUCCESS,
        payload: data
    };
};

export const fetchCampaignsFail = () => {
    return {
        type: FETCH_CAMPAIGNS_FAIL
    };
};

//fetching perimeter attack meta
export const fetchPerimeterAttacksMetaAction = (data) => {
    return {
        type: FETCH_PERIMETER_ATTACKS_META,
        payload: data
    };
};

export const fetchPerimeterAttacksMetaSuccess = (data) => {
    return {
        type: FETCH_PERIMETER_ATTACKS_META_SUCCESS,
        payload: data
    };
};

export const fetchPerimeterAttacksMetasFail = () => {
    return {
        type: FETCH_PERIMETER_ATTACKS_META_FAIL
    };
};

//adding new customers
export const addNewCustomerAction = (data) => {
    return {
        type: ADD_CUSTOMER,
        payload: data
    };
};

export const addNewCustomerSuccess = (data) => {
    return {
        type: ADD_CUSTOMER_SUCCESS,
        payload: data
    };
};

export const addNewCustomerFail = () => {
    return {
        type: ADD_CUSTOMER_FAIL
    };
};

/*  jfd*******************************
 *   /set target scope (disable or enable)
     ********************************** */
export const setTargetScopeAction = (data) => {
    return {
        type: SET_TARGET_SCOPE,
        payload: data
    };
};

export const setTargetScopeSuccess = (data) => {
    return {
        type: SET_TARGET_SCOPE_SUCCESS,
        payload: data
    };
};

export const setTargetScopeFail = (data) => {
    return {
        type: SET_TARGET_SCOPE_FAIL,
        payload: data
    };
};



//MODULES
/*  jfd*******************************
 *   /ACTIVATE MODULE  STATUS FOR CUSTOMERS
     ********************************** */
export const activateCustomerModule = (data) => {
    return {
        type: CUSTOMER_MODULE_ACTIVATE,
        payload: data,
    };
};

export const activateCustomerModuleSuccess = (data) => {
    return {
        type: CUSTOMER_MODULE_ACTIVATE_SUCCESS,
        payload: data
    };
};

export const activateCustomerModuleFail = (data) => {
    return {
        type: CUSTOMER_MODULE_ACTIVATE_FAIL,
        payload: data
    };
};

/*  jfd*******************************
 *   /DEACTIVATE MODULE
     ********************************** */

export const deactivateCustomerModule = (data) => {
    return {
        type: CUSTOMER_MODULE_DEACTIVATE,
        payload: data,
    };
};

export const deactivateCustomerModuleSuccess = (data) => {
    return {
        type: CUSTOMER_MODULE_DEACTIVATE_SUCCESS,
        payload: data
    };
};

export const deactivateCustomerModuleFail = (data) => {
    return {
        type: CUSTOMER_MODULE_DEACTIVATE_FAIL,
        payload: data
    };
};

//SUBSCRIPTION
/*  jfd*******************************
 *   /ACTIVATE SUBSCRIPTION  STATUS FOR CUSTOMERS
     ********************************** */
export const activateCustomerSubscription = (data) => {
    return {
        type: CUSTOMER_SUBSCRIPTION_ACTIVATE,
        payload: data,
    };
};

export const activateCustomerSubscriptionSuccess = (data) => {
    return {
        type: CUSTOMER_SUBSCRIPTION_ACTIVATE_SUCCESS,
        payload: data
    };
};

export const activateCustomerSubscriptionFail = (data) => {
    return {
        type: CUSTOMER_SUBSCRIPTION_ACTIVATE_FAIL,
        payload: data
    };
};

/*  jfd*******************************
 *   /DEACTIVATE SUBSCRIPTION
     ********************************** */

export const deactivateCustomerSubscription = (data) => {
    return {
        type: CUSTOMER_SUBSCRIPTION_DEACTIVATE,
        payload: data,
    };
};

export const deactivateCustomerSubscriptionSuccess = (data) => {
    return {
        type: CUSTOMER_SUBSCRIPTION_DEACTIVATE_SUCCESS,
        payload: data
    };
};

export const deactivateCustomerSubscriptionFail = (data) => {
    return {
        type: CUSTOMER_SUBSCRIPTION_DEACTIVATE_FAIL,
        payload: data
    };
};

/*  jfd************15.FEB.2022*******************
 *   /CUSTOMER TAGS
     ********************************** */
// ****** SUCCESS AND FAIL FUNCTIONS ********
const addTagCustomerSuccess = (data) => {
    return{
        type: ADD_TAG_CUSTOMER_SUCCESS,
        payload: data
    }
}

const addTagCustomerFail = (data) => {
    return{
        type: ADD_TAG_CUSTOMER_FAIL,
        payload: data
    }
}

const updateTagCustomerSuccess = (data) => {
    return{
        type: UPDATE_TAG_CUSTOMER_SUCCESS,
        payload: data
    }
}

const updateTagCustomerFail = (data) => {
    return{
        type: UPDATE_TAG_CUSTOMER_FAIL,
        payload: data
    }
}

// *****  EARLY ACCESS TAGS  ********

/**
 * Summary. enableEarlyAccess.
 *
 * Description. Adds an early access tag to the customer object.
 *
 *  @param {string}   customerId             CustomerId to affect
 *
 * @return
 *
 * @example
 */
export const enableCustomerEarlyAccess = ( customerId,) => {
    //Early Access is tag id 54
    return addTag(
        addTagCustomerSuccess, //successAction
        addTagCustomerFail, //failAction
        54, //definitionId
        null, //entityId
        null, //targetId
        null, //vectorId
        null, //testedVectorId
        null, //identityid
        null, //details
        null, //userId
        customerId, //customerId
        null, //subportfolioId
        true, //showUserMessage
        null, //affectedElementId
    );
};

/**
 * Summary. disableEarlyAccess.
 *
 * Description. Sets an existing Early Access tag ot is_active: false, disabling access.
 *
 *  @param {object}   tag             tag to affect
 *  @param {string}   customerId             CustomerId to affect
 *
 * @return
 *
 * @example
 */
export const disableCustomerEarlyAccess = ( tag, customerId) => {
    //Early Access is 54
    if(bbIsObject(tag) && tag.definition.id === 54) {
        //TODO: verify that the tag is of type
        return updateTag(
            updateTagCustomerSuccess,
            updateTagCustomerFail,
            tag.id,
            false,
            customerId
            );
    } else {
        return updateTagCustomerFail({
            tagId: tag.id
        })
    }
};


/*  sarahp**********06.09.22*****
 *  Get Users for Customer
     **********************  */

export const fetchUsersForCustomer = (data) =>{
    return{
        type: FETCH_USERS_FOR_CUSTOMER,
        payload: data
    }
}

export const fetchUsersForCustomerSuccess = (data) =>{
    return{
        type: FETCH_USERS_FOR_CUSTOMER_SUCCESS,
        payload: data
    }
}

export const fetchUsersForCustomerFail = (data) =>{
    return{
        type: FETCH_USERS_FOR_CUSTOMER_FAIL,
        payload: data
    }
}

/*  sarahp**********06.09.22*****
 *  POST Users for Customer
     **********************  */
export const createUserForCustomer = (customerId, email, isManager, firstName, lastName) =>{
    return{
        type: CREATE_USER_FOR_CUSTOMER,
        payload: {
            customerId,
            email,
            isManager,
            firstName,
            lastName,
        }
    }
}

export const createUserForCustomerSuccess = (data) =>{
    return{
        type: CREATE_USER_FOR_CUSTOMER_SUCCESS,
        payload: data
    }
}

export const createUserForCustomerFail = (data) =>{
    return{
        type: CREATE_USER_FOR_CUSTOMER_FAIL,
        payload: data
    }
}

/*  sarahp**********06.09.22*****
 *  DEL Users for Customer
     **********************  */

export const deleteUserForCustomer = (customerId, idToDelete) =>{
    console.log("idToDelete inside action", idToDelete, )

    return{
        type: DELETE_USER_FOR_CUSTOMER,
        payload: {
            customerId,
            idToDelete,
        }
    }
}

export const deleteUserForCustomerSuccess = (data) =>{
    return{
        type: DELETE_USER_FOR_CUSTOMER_SUCCESS,
        payload: data
    }
}

export const deleteUserForCustomerFail = (data) =>{
    return{
        type: DELETE_USER_FOR_CUSTOMER_FAIL,
        payload: data
    }
}

/*  sarahp**********12.09.22*****
 *  DEL Users for Customer -- INVITE ONLY
     **********************  */

export const deleteUserForCustomerInvite = (customerId, idToDelete) =>{
    console.log("idToDelete inside action", idToDelete, )

    return{
        type: DELETE_USER_FOR_CUSTOMER_INVITE,
        payload: {
            customerId,
            idToDelete,
        }
    }
}

export const deleteUserForCustomerInviteSuccess = (data) =>{
    return{
        type: DELETE_USER_FOR_CUSTOMER_INVITE_SUCCESS,
        payload: data
    }
}

export const deleteUserForCustomerInviteFail = (data) =>{
    return{
        type: DELETE_USER_FOR_CUSTOMER_INVITE_FAIL,
        payload: data
    }
}

/*  sarahp**********07.05.2023*****
 *  Update Customer Name
     **********************  */

export const updateCustomerName = (customerId, customerName) =>{
    console.log("should be action for updateCustomerName", customerId, customerName)
    return {
        type: UPDATE_CUSTOMER_NAME,
        payload: {
            customerId,
            customerName
        }
    }
};

export const updateCustomerNameSuccess = (data) =>{
    return {
        type: UPDATE_CUSTOMER_NAME_SUCCESS,
        payload: data
    }
};

export const updateCustomerNameFail = (data) =>{
    return {
        type: UPDATE_CUSTOMER_NAME_FAIL,
        payload: data
    }
};
